/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateClassRequest,
  DeleteClassResponse,
  GenerateClassScheduleResponse,
  GetAvailableClassesRequest,
  GetBulkClassesRequest,
  GetBulkClassesResponse,
  GetClassResponse,
  PaginatedResultOfGetAvailableClassResponse,
  PaginatedResultOfGetClassResponse,
  Result,
  ResultOfCreateClassResponse,
  SearchQueryRequest,
  UpdateClassRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateClassRequestFromJSON,
    CreateClassRequestToJSON,
    DeleteClassResponseFromJSON,
    DeleteClassResponseToJSON,
    GenerateClassScheduleResponseFromJSON,
    GenerateClassScheduleResponseToJSON,
    GetAvailableClassesRequestFromJSON,
    GetAvailableClassesRequestToJSON,
    GetBulkClassesRequestFromJSON,
    GetBulkClassesRequestToJSON,
    GetBulkClassesResponseFromJSON,
    GetBulkClassesResponseToJSON,
    GetClassResponseFromJSON,
    GetClassResponseToJSON,
    PaginatedResultOfGetAvailableClassResponseFromJSON,
    PaginatedResultOfGetAvailableClassResponseToJSON,
    PaginatedResultOfGetClassResponseFromJSON,
    PaginatedResultOfGetClassResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateClassResponseFromJSON,
    ResultOfCreateClassResponseToJSON,
    SearchQueryRequestFromJSON,
    SearchQueryRequestToJSON,
    UpdateClassRequestFromJSON,
    UpdateClassRequestToJSON,
} from '../models/index';

export interface ApiClassesBulkPostRequest {
    getBulkClassesRequest: GetBulkClassesRequest;
    xTenantID?: number;
}

export interface ApiClassesByTeacherTeacherIdGetRequest {
    teacherId: number;
    xTenantID?: number;
}

export interface ApiClassesEnrollmentAvailablePostRequest {
    getAvailableClassesRequest: GetAvailableClassesRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiClassesIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassesIdScheduleGetRequest {
    id: number;
    month?: ApiUserTasksGetPageParameter;
    year?: ApiUserTasksGetPageParameter;
    xTenantID?: number;
}

export interface ApiClassesPostRequest {
    createClassRequest: CreateClassRequest;
    xTenantID?: number;
}

export interface ApiClassesPutRequest {
    updateClassRequest: UpdateClassRequest;
    xTenantID?: number;
}

export interface ApiClassesScrollGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiClassesSearchPostRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
    searchQueryRequest?: SearchQueryRequest;
}

export interface GetClassByIdRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class ClassesApi extends runtime.BaseAPI {

    /**
     * Returns classes for up to 100 class IDs in one request. Empty or null classIds returns { items: [] }. Unknown IDs (including other-tenant) are omitted. Same authorization as GET /api/classes/{id} ([AllowAnonymous] plus X-Tenant-ID).
     * Get classes in bulk
     */
    async apiClassesBulkPostRaw(requestParameters: ApiClassesBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBulkClassesResponse>> {
        if (requestParameters['getBulkClassesRequest'] == null) {
            throw new runtime.RequiredError(
                'getBulkClassesRequest',
                'Required parameter "getBulkClassesRequest" was null or undefined when calling apiClassesBulkPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBulkClassesRequestToJSON(requestParameters['getBulkClassesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBulkClassesResponseFromJSON(jsonValue));
    }

    /**
     * Returns classes for up to 100 class IDs in one request. Empty or null classIds returns { items: [] }. Unknown IDs (including other-tenant) are omitted. Same authorization as GET /api/classes/{id} ([AllowAnonymous] plus X-Tenant-ID).
     * Get classes in bulk
     */
    async apiClassesBulkPost(requestParameters: ApiClassesBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBulkClassesResponse> {
        const response = await this.apiClassesBulkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of classes taught by the specified teacher ID
     * Get classes by teacher
     */
    async apiClassesByTeacherTeacherIdGetRaw(requestParameters: ApiClassesByTeacherTeacherIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetClassResponse>>> {
        if (requestParameters['teacherId'] == null) {
            throw new runtime.RequiredError(
                'teacherId',
                'Required parameter "teacherId" was null or undefined when calling apiClassesByTeacherTeacherIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/by-teacher/{teacherId}`;
        urlPath = urlPath.replace(`{${"teacherId"}}`, encodeURIComponent(String(requestParameters['teacherId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetClassResponseFromJSON));
    }

    /**
     * Returns a list of classes taught by the specified teacher ID
     * Get classes by teacher
     */
    async apiClassesByTeacherTeacherIdGet(requestParameters: ApiClassesByTeacherTeacherIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetClassResponse>> {
        const response = await this.apiClassesByTeacherTeacherIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves available classes for enrollment filtered by the specified student\'s year, gender, and season criteria.
     * Get available classes for enrollment
     */
    async apiClassesEnrollmentAvailablePostRaw(requestParameters: ApiClassesEnrollmentAvailablePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetAvailableClassResponse>> {
        if (requestParameters['getAvailableClassesRequest'] == null) {
            throw new runtime.RequiredError(
                'getAvailableClassesRequest',
                'Required parameter "getAvailableClassesRequest" was null or undefined when calling apiClassesEnrollmentAvailablePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/enrollment-available`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAvailableClassesRequestToJSON(requestParameters['getAvailableClassesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetAvailableClassResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves available classes for enrollment filtered by the specified student\'s year, gender, and season criteria.
     * Get available classes for enrollment
     */
    async apiClassesEnrollmentAvailablePost(requestParameters: ApiClassesEnrollmentAvailablePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetAvailableClassResponse> {
        const response = await this.apiClassesEnrollmentAvailablePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete class
     */
    async apiClassesIdDeleteRaw(requestParameters: ApiClassesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteClassResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteClassResponseFromJSON(jsonValue));
    }

    /**
     * Delete class
     */
    async apiClassesIdDelete(requestParameters: ApiClassesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteClassResponse> {
        const response = await this.apiClassesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates and returns the list of scheduled class sessions for the specified class
     * Generate class schedule
     */
    async apiClassesIdScheduleGetRaw(requestParameters: ApiClassesIdScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateClassScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassesIdScheduleGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/{id}/schedule`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateClassScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Generates and returns the list of scheduled class sessions for the specified class
     * Generate class schedule
     */
    async apiClassesIdScheduleGet(requestParameters: ApiClassesIdScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateClassScheduleResponse> {
        const response = await this.apiClassesIdScheduleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create class
     */
    async apiClassesPostRaw(requestParameters: ApiClassesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateClassResponse>> {
        if (requestParameters['createClassRequest'] == null) {
            throw new runtime.RequiredError(
                'createClassRequest',
                'Required parameter "createClassRequest" was null or undefined when calling apiClassesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClassRequestToJSON(requestParameters['createClassRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateClassResponseFromJSON(jsonValue));
    }

    /**
     * Create class
     */
    async apiClassesPost(requestParameters: ApiClassesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateClassResponse> {
        const response = await this.apiClassesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update class
     */
    async apiClassesPutRaw(requestParameters: ApiClassesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateClassRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClassRequest',
                'Required parameter "updateClassRequest" was null or undefined when calling apiClassesPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClassRequestToJSON(requestParameters['updateClassRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update class
     */
    async apiClassesPut(requestParameters: ApiClassesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassesPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get all classes
     */
    async apiClassesScrollGetRaw(requestParameters: ApiClassesScrollGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetClassResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetClassResponseFromJSON(jsonValue));
    }

    /**
     * Get all classes
     */
    async apiClassesScrollGet(requestParameters: ApiClassesScrollGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetClassResponse> {
        const response = await this.apiClassesScrollGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search classes
     */
    async apiClassesSearchPostRaw(requestParameters: ApiClassesSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetClassResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQueryRequestToJSON(requestParameters['searchQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetClassResponseFromJSON(jsonValue));
    }

    /**
     * Search classes
     */
    async apiClassesSearchPost(requestParameters: ApiClassesSearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetClassResponse> {
        const response = await this.apiClassesSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get class
     */
    async getClassByIdRaw(requestParameters: GetClassByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClassResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClassById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/classes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClassResponseFromJSON(jsonValue));
    }

    /**
     * Get class
     */
    async getClassById(requestParameters: GetClassByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClassResponse> {
        const response = await this.getClassByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
